import { lazy, Suspense } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";

// Lazy load non-critical UI components
const Toaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));
const Sonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));
const TopBar = lazy(() => import("./components/TopBar"));
const CookieBanner = lazy(() => import("./components/CookieBanner"));
// Lazy load non-critical routes
const Services = lazy(() => import("./pages/Services"));
const Contact = lazy(() => import("./pages/Contact"));
const Realisations = lazy(() => import("./pages/Realisations"));
const MentionsLegales = lazy(() => import("./pages/MentionsLegales"));
const PolitiqueConfidentialite = lazy(() => import("./pages/PolitiqueConfidentialite"));
const Devis = lazy(() => import("./pages/Devis"));
const DevisMerci = lazy(() => import("./pages/DevisMerci"));
const NotFound = lazy(() => import("./pages/NotFound"));
const AdminLogin = lazy(() => import("./pages/admin/Login"));
const AdminLayout = lazy(() => import("./pages/admin/AdminLayout"));
const DevisAdmin = lazy(() => import("./pages/admin/DevisAdmin"));
const ContactsAdmin = lazy(() => import("./pages/admin/ContactsAdmin"));
const RealisationsAdmin = lazy(() => import("./pages/admin/RealisationsAdmin"));
const SettingsAdmin = lazy(() => import("./pages/admin/SettingsAdmin"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Suspense fallback={null}>
        <Toaster />
        <Sonner />
      </Suspense>
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={null}>
          <Routes>
            {/* Public routes with TopBar */}
            <Route path="/" element={<><Suspense fallback={null}><TopBar /></Suspense><Index /></>} />
            <Route path="/services" element={<><Suspense fallback={null}><TopBar /></Suspense><Services /></>} />
            <Route path="/contact" element={<><Suspense fallback={null}><TopBar /></Suspense><Contact /></>} />
            <Route path="/realisations" element={<><Suspense fallback={null}><TopBar /></Suspense><Realisations /></>} />
            <Route path="/mentions-legales" element={<><Suspense fallback={null}><TopBar /></Suspense><MentionsLegales /></>} />
            <Route path="/politique-de-confidentialite" element={<><Suspense fallback={null}><TopBar /></Suspense><PolitiqueConfidentialite /></>} />
            <Route path="/devis" element={<><Suspense fallback={null}><TopBar /></Suspense><Devis /></>} />
            <Route path="/devis-merci" element={<><Suspense fallback={null}><TopBar /></Suspense><DevisMerci /></>} />

            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<DevisAdmin />} />
              <Route path="contacts" element={<ContactsAdmin />} />
              <Route path="realisations" element={<RealisationsAdmin />} />
              <Route path="settings" element={<SettingsAdmin />} />
            </Route>

            <Route path="*" element={<><Suspense fallback={null}><TopBar /></Suspense><NotFound /></>} />
          </Routes>
        </Suspense>
        <Suspense fallback={null}>
          <CookieBanner />
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
